import { RootState } from '../index';
import { IUserState } from './reducer';

export const selectIsLoggedIn = (state: RootState): IUserState['isLoggedIn'] => state.user.isLoggedIn;

export const selectAdminUserProfile = (state: RootState): IUserState => state.user;
